
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";

//AOZMEN;452648;25032025
function RevisedTraumaScoreCreate() {
  const { t } = useTranslate();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
      "success"
    );
  
    const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleSaveMedcard = async () => {
    try {
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };
  
  return (
    <>
    <Stack
      sx={{ padding: "5px", marginBottom: "20px" }}
      mt={5}
      direction="row"
      spacing={2}
    >
      <ByzNurseSaveButton onClick={handleSaveMedcard} />
      <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
      <ByzNursePrintButton />
    
    </Stack>

    <Box sx={{ padding: "20px", width: "100%" }}>
      <Grid container spacing={2}>
        <Grid md={6} xs={6} container direction={"column"} spacing={3}>
          <Grid
            md={6}
            xs={6}
            sx={{
              backgroundColor: "#F4F7FE",
              borderBottom: "1px solid #E0E0E0",
            }}
          >
            <ByzMuiTypography sx={{fontWeight : 700}}>{t("revised-trauma-score.title")}</ByzMuiTypography>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("datetime")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
              <ByzMuiDateTimePicker sx={{ width: "300px" }} />
            </Grid>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("createdby")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
              <ByzMuiTextField
                sx={{ width: "100%", maxWidth: "300px" }}
                disabled
                label={t("createdby")}
              />
            </Grid>
          </Grid>

          <Grid
            md={6}
            xs={6}
            sx={{
              backgroundColor: "#F4F7FE",
              borderBottom: "1px solid #E0E0E0",
            }}
          >
            <ByzMuiTypography fontWeight={700} >
              {t("revised-trauma-score.patient-related-factors")}
            </ByzMuiTypography>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("revised-trauma-score.systolic-blood-pressure")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
              <ByzMuiSelect
                renderInput={(params: any) => <ByzMuiTextField {...params} />}
                options={[]}
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{marginLeft: "30px" }}>
                {t("revised-trauma-score.respiratory-rate")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
              <ByzMuiSelect
                renderInput={(params: any) => <ByzMuiTextField {...params} />}
                options={[]}
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} display={'flex'} direction={'row'} sx={{ borderBottom: "1px solid #E0E0E0" }} >
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("revised-trauma-score.glasgow-score")}
              </ByzMuiTypography>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                |
              </ByzMuiTypography>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("revised-trauma-score.score")}
              </ByzMuiTypography>
            </Grid>
              <Grid md={6} xs={6} display={'flex'} direction={'row'} >
                <Grid gap={2} display={'flex'} direction={'row'} md={6} xs={6} sx={{ paddingTop: "0px" }}>
                  <ByzMuiTextField
                    disabled
                    sx={{ width: "100%", maxWidth: "300px" }}
                    label={t("revised-trauma-score.score-value")}
                  />
                  <ByzMuiTextField
                    disabled
                    sx={{ width: "100%", maxWidth: "300px" }}
                    label={t("revised-trauma-score.score")}
                  />
                </Grid>
            </Grid>
          </Grid>

          <Grid
            md={6}
            xs={6}
            sx={{
              backgroundColor: "#F4F7FE",
              borderBottom: "1px solid #E0E0E0",
            }}
          >
            <ByzMuiTypography sx={{fontWeight : 700}}>{t("revised-trauma-score.other")}</ByzMuiTypography>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("revised-trauma-score.two-score")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
              <ByzMuiTextField
                sx={{ width: "100%", maxWidth: "300px" }}
                label={t("revised-trauma-score.two-score")}
                disabled
              />
            </Grid>
          </Grid>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                {t("revised-trauma-score.note")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
              <ByzMuiTextField
                sx={{ width: "100%", maxWidth: "300px" }}
                label={t("revised-trauma-score.note")}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
    <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={
                alertSeverity === "success"
                  ? t("operation-successful")
                  : t("error")
              }
              message={alertMessage}
              type={alertSeverity}
            />
  </>
  );
}
export default RevisedTraumaScoreCreate;

